import _ from "lodash";
import { TFilesData } from "_common/_utils/fetchUtils";
import imageCompression from "browser-image-compression";

const files: { [url: string]: File | Blob } = {};

export function getWebpFile(fileName: string | undefined) {
    if (!fileName) return undefined;
    if (fileName?.includes("blob")) return fileName;
    fileName = fileName.toLowerCase();
    const arrName = fileName.split(".");
    return `${arrName[0]}.webp`;
}

export function getFileUrl(file: File | Blob) {
    return URL.createObjectURL(file);
}

export function storeFile(file: File | Blob) {
    const url = getFileUrl(file);
    files[url] = file;
    return url;
}

export function getFile(url: string) {
    return files[url];
}

export function hasImageExtension(name: string) {
    name = name.toLowerCase();
    return (
        name.endsWith("jpg") ||
        name.endsWith("jpeg") ||
        name.endsWith("png") ||
        name.endsWith("gif") ||
        name.endsWith("svg") ||
        name.endsWith("bmp")
    );
}

export function isBlobUrl(url: string) {
    return url.startsWith("blob:");
}

export function isImage(url: string) {
    let name = url;
    const isBlob = isBlobUrl(url);
    if (isBlob) name = getFile(url)?.name ?? url;
    return hasImageExtension(name);
}

async function createFileData(url: string, path: string, maxWidthOrHeight?: number, index?: number) {
    if (isBlobUrl(url)) {
        let blob: File | Blob = getFile(url);
        if (!blob) return;
        blob = maxWidthOrHeight && isImage(url) ? await imageCompression(blob, { maxWidthOrHeight }) : blob;
        const indexes = index !== undefined ? [index] : undefined;
        return { path, blob, indexes };
    }
}

export async function createFilesData(
    value: undefined | null | string | string[],
    path: string,
    maxWidthOrHeight?: number,
) {
    let filesData: TFilesData | undefined;
    if (value) {
        if (_.isArray(value)) {
            await Promise.all(
                value.map(async (url, index) => {
                    const fileData = await createFileData(url, path, maxWidthOrHeight, index);
                    if (fileData) {
                        filesData = filesData ?? [];
                        filesData.push(fileData);
                    }
                }),
            );
        } else {
            const fileData = await createFileData(value, path, maxWidthOrHeight);
            if (fileData) filesData = [fileData];
        }
    }
    return filesData;
}
